<template>
  <div class="customer-todo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>我的待办</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="main">
      <div slot="header" class="clearfix">
        <span>
          <b style="font-size:14px">我的待办</b>
          <span style="margin-left:8px;color:#909399;font-size:12px;">运营推送的需您确认/办结事项</span>
        </span>
        <el-button style="float:right;" size="mini" icon="el-icon-refresh" @click="loadList" :loading="loading">刷新</el-button>
      </div>
      <el-table v-loading="loading" :data="list" style="width:100%" empty-text="暂无待办">
        <el-table-column label="标题" min-width="180">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="openDetail(scope.row)">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="分类" prop="category" width="90">
          <template slot-scope="scope">{{ categoryLabel(scope.row.category) }}</template>
        </el-table-column>
        <el-table-column label="客户单号" prop="clientNo" width="140" show-overflow-tooltip />
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === '1' ? 'warning' : 'info'">
              {{ statusLabel(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :loading="completingId === scope.row.id"
              @click="complete(scope.row)"
            >办结</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="detail.title || '待办详情'" :visible.sync="detailVisible" :close-on-click-modal="false" width="520px">
      <div class="detail-body">
        <p><b>分类：</b>{{ categoryLabel(detail.category) }}</p>
        <p v-if="detail.clientNo"><b>客户单号：</b>{{ detail.clientNo }}</p>
        <p v-if="detail.bizNo"><b>业务单号：</b>{{ detail.bizNo }}</p>
        <div class="content" v-html="safeDetailContent"></div>
      </div>
      <span slot="footer">
        <el-button size="small" @click="detailVisible=false">关闭</el-button>
        <el-button size="small" type="primary" :loading="completingId === detail.id" @click="complete(detail)">办结</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpApi from '@/http/api'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

const CATEGORY = {
  exception: '异常',
  fee: '费用',
  hold: '扣货',
  customs: '清关',
  other: '其它'
}
const STATUS = {
  '0': '待处理',
  '1': '处理中',
  '2': '已关闭',
  '3': '已取消'
}

export default {
  name: 'CustomerTodo',
  data() {
    return {
      loading: false,
      list: [],
      detailVisible: false,
      detail: {},
      completingId: null
    }
  },
  computed: {
    safeDetailContent() {
      return sanitizeHtml(this.detail.content || '-')
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    categoryLabel(c) {
      return CATEGORY[c] || c || '-'
    },
    statusLabel(s) {
      return STATUS[s] || s || '-'
    },
    loadList() {
      this.loading = true
      httpApi
        .customerTodoList()
        .then(res => {
          if (res.data.code === 'ok') {
            this.list = res.data.data || []
          } else {
            this.$message.error(res.data.message || '加载失败')
          }
        })
        .catch(() => this.$message.error('加载失败'))
        .finally(() => {
          this.loading = false
        })
    },
    openDetail(row) {
      this.detail = Object.assign({}, row)
      this.detailVisible = true
    },
    complete(row) {
      if (!row || !row.id) return
      this.$confirm('确认办结该待办？办结后将通知运营侧关闭。', '办结确认', {
        type: 'warning',
        confirmButtonText: '办结',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.completingId = row.id
          return httpApi.customerTodoComplete({ id: row.id })
        })
        .then(res => {
          if (res.data.code === 'ok') {
            this.$message.success('已办结')
            this.detailVisible = false
            this.loadList()
          } else {
            this.$message.error(res.data.message || '办结失败')
          }
        })
        .catch(err => {
          if (err !== 'cancel' && err !== 'close') {
            this.$message.error((err && err.message) || '办结失败')
          }
        })
        .finally(() => {
          this.completingId = null
        })
    }
  }
}
</script>

<style scoped>
.customer-todo .main {
  margin-top: 12px;
}
.detail-body p {
  margin: 6px 0;
  font-size: 13px;
}
.detail-body .content {
  margin-top: 12px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.6;
}
</style>
